import type { Client, RequestContext } from "../client";
import type { RetentionDefaultConfigurationResource } from "../resources/retentionDefaultConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";

export class RetentionDefaultConfigurationRepository extends ConfigurationRepository<RetentionDefaultConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("RetentionDefaultConfiguration", client, requestContext);
    }
}
